import React, { useState } from "react"
import styled from "styled-components"
import { Container, H5, BigContainer } from "../general/GeneralStyles"
import axios from "axios"
import { Link } from "gatsby"
import Img from "gatsby-image"

const FooterContainer = styled.div`
  /* display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr; */
  hr {
    margin-bottom: 0;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    ${H5} {
      text-align: center;
    }
  }
`

const BottomFooterContainer = styled.div`
  background: ${props => props.theme.primaryColor};
`

const BottomFooter = styled(BigContainer)`
  color: white;
  display: flex;
  flex-direction: row;
  max-width: 1400px;
  width: 90%;
  justify-content: space-between;
  margin: 0 auto;
  padding: 15px 0;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

const BottomLink = styled(Link)`
  color: #fffefc;
  font-family: ${props => props.theme.primaryFont};
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  text-decoration: none;

  a {
    color: #fffefc;
    font-family: ${props => props.theme.primaryFont};
    font-size: 18px;
    font-weight: 900;
    line-height: 24px;
    text-decoration: none;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    padding-bottom: 20px;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    line-height: 35px;
  }
`

const BottomAnchor = styled.a`
  color: #fffefc;
  font-family: ${props => props.theme.primaryFont};
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  text-decoration: none;

  a {
    color: #fffefc;
    font-family: ${props => props.theme.primaryFont};
    font-size: 18px;
    font-weight: 900;
    line-height: 24px;
    text-decoration: none;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    padding-bottom: 20px;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    line-height: 35px;
  }
`

const TopLink = styled(Link)`
  color: ${props => props.theme.secondaryTextColor};
  font-family: ${props => props.theme.primaryFont};
  text-decoration: none;
  font-size: 16px;
  line-height: 24px;
  width: 100% !important;

  &:hover {
    /* text-decoration: underline; */
    color: ${props => props.theme.primaryColor};
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    line-height: 35px;
  }
`

const TopExternalLink = styled.a`
  color: ${props => props.theme.secondaryTextColor};
  font-family: ${props => props.theme.primaryFont};
  text-decoration: none;
  font-size: 16px;
  line-height: 24px;
  width: 100% !important;
  position: relative;

  &::before {
    content: url("/images/icons/recycle.png");
    position: absolute;
    left: -22px;
    top: 3px;
  }

  &:hover {
    /* text-decoration: underline; */
    color: ${props => props.theme.primaryColor};
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    line-height: 35px;
  }
`

const TopFooter = styled(BigContainer)`
  display: grid;
  margin: 0 auto;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 32px;
  align-items: center;
  padding: 17px 0;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-template-columns: 1fr;
    grid-gap: 30px;
    justify-content: center;
    > div {
      max-width: 300px;
      margin: 0 auto;
    }
  }
`

const TopFooterSeparator = styled.div`
  height: 72%;
  width: 2px;
  background: #f0efea;
  display: flex;
  align-self: center;
  justify-self: center;
  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    display: none;
  }
`

const MainMenuContainer = styled.div`
  grid-column: 4 / 8;

  ${H5} {
    margin-bottom: 0px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-column: unset;
  }
`

const MainMenu = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 34px;

  > * {
    width: 50%;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    flex-direction: column;
    text-align: center;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-gap: 10px;

    > * {
      width: 100%;
    }
  }
`

const ThirdColumn = styled.div`
  grid-column: 9 / 12;

  ${H5} {
    margin-bottom: 5px;
  }

  img {
    margin-right: 20px;
    margin-bottom: 5px;

    @media (max-width: ${props => props.theme.smallBreakpoint}) {
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    text-align: center;
    grid-column: unset;
  }
`

const FooterLogos = styled.div`
  text-align: center;
  grid-column: 1 / span 3;

  img {
    max-width: 130px;
    display: block;
    margin: 0 auto;
    margin-bottom: 4px;
  }

  span {
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.primaryFont};
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    display: inline-block;
  }

  span:nth-child(2) {
    padding-bottom: 25px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-column: unset;
  }
`

const Button = styled.span`
  display: inline-block;
  color: #ffffff;
  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  padding: 9px 20px;
  vertical-align: middle;
  background: ${props => props.theme.primaryColor};
  cursor: pointer;
`

const EmailInput = styled.input`
  color: #6b706a;
  vertical-align: middle;
  font-family: Lato;
  font-size: 13px;
  line-height: 16px;
  border: 2px solid #f0efea;
  padding: 7px 20px;
  border-right: 0px;
`

const Footer = props => {
  const [listEmail, setListEmail] = useState(listEmail)

  const inputHandler = e => {
    console.log("in ipnut handler")
    setListEmail(e.target.value)
  }

  const JoinMailingList = () => {
    if (listEmail.includes("@")) {
      axios
        .post("/mailinglists", { email: listEmail })
        .then(response => {
          console.log(response)
          if (response) {
            alert("Your email has been added to our Mailing List")
          }
        })
        .catch(error => {
          alert("Something went wrong please try again")
          console.log(error)
        })
    } else {
      alert("Please enter a valid email")
    }
  }

  return (
    <FooterContainer>
      <hr />
      <TopFooter>
        <FooterLogos>
          <img src="/images/prang_logo.png" alt="" />
          <span>© Copyright 2019 Dixon Ticonderoga</span>
          <img src="/images/fila_logo.png" alt="" />
          <span>www.fila.it</span>
        </FooterLogos>
        <MainMenuContainer>
          <H5>Prang Power</H5>
          <MainMenu>
            <TopLink to="/">Home</TopLink>
            <TopLink to="/contact-us">Contact Us</TopLink>
            <TopLink to="/how-it-works">How It Works</TopLink>
            <TopLink to="/program-rules">Program Rules</TopLink>
            <TopLink to="/products">Products</TopLink>
            <TopLink to="/privacy-policy">Privacy Policy</TopLink>
            <TopLink to="/sign-up">Sign Up</TopLink>
            <TopLink to="/login">Login</TopLink>
            <TopExternalLink
              href="https://www.terracycle.com/en-US/brigades/dixon"
              target="_blank"
            >
              Terracycle Recycle
            </TopExternalLink>
          </MainMenu>
        </MainMenuContainer>
        <TopFooterSeparator />
        <ThirdColumn>
          {/* <H5>Follow Us</H5>
          <div>
            <a href="https://www.facebook.com/WeAreTiconderoga/">
              <img src="/images/icons/fb.png" alt="" />
            </a>
            <a href="https://twitter.com/DIXONTICPRANG">
              <img src="/images/icons/twitter.png" alt="" />
            </a>
          </div> */}
          <H5>Join our Mailing List</H5>
          <EmailInput
            type="email"
            placeholder="Email Address"
            value={listEmail}
            onChange={inputHandler}
          />
          <Button onClick={JoinMailingList}>Join</Button>
        </ThirdColumn>
      </TopFooter>
      <BottomFooterContainer>
        <BottomFooter>
          <BottomAnchor href="https://www.prang.com" target="_blank">
            Prang
          </BottomAnchor>
          <BottomAnchor href="https://weareticonderoga.com" target="_blank">
            Ticonderoga
          </BottomAnchor>
          <BottomAnchor href="https://dixonwriting.com" target="_blank">
            Dixon
          </BottomAnchor>
          <BottomAnchor href="https://www.dixonpromo.com" target="_blank">
            Promotions
          </BottomAnchor>
          <BottomLink to="/contact-us">Contact</BottomLink>
          <BottomLink href="#" />
        </BottomFooter>
      </BottomFooterContainer>
    </FooterContainer>
  )
}

export default Footer
